export { RedesignedSuggestionList } from './redesigned-suggestion-list';
